import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ICON_TYPE, LaunchDialogService } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'firmware-image-dialog',
  templateUrl: './firmware-image-dialog.component.html',
  styleUrls: ['./firmware-image-dialog.component.scss'],
  standalone: false,
})
export class FirmwareImageDialogComponent implements OnInit, OnDestroy {
  iconTypes = ICON_TYPE;

  data$?: Observable<string> = this.launchDialogService.data$;
  imageURL?: string;
  subscription: Subscription | undefined;

  @ViewChild('dialog', { read: ElementRef })
  dialog!: ElementRef;

  constructor(protected launchDialogService: LaunchDialogService) {}

  ngOnInit(): void {
    this.subscription = this.data$?.subscribe((value) => {
      if (value != null) {
        this.imageURL = value;
      }
    });
  }

  dismissModal(reason?: any): void {
    this.launchDialogService.closeDialog(reason);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
